import { clsx } from 'clsx';
import { forwardRef, HTMLAttributes } from 'react';

import s from './XText.module.less';
import { XTextColor, XTextVariant } from './XText.types';

interface Props extends HTMLAttributes<Omit<HTMLSpanElement, 'color'>> {
  className?: string;
  color?: XTextColor;
  crossed?: boolean;
  semibold?: boolean;
  bold?: boolean;
  variant?: XTextVariant;
}

export const XText = forwardRef<HTMLSpanElement, Props>(
  ({ className, color, crossed, semibold, bold, variant, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={clsx(
          color ? s[color] : undefined,
          crossed && s.crossed,
          semibold && s.semibold,
          bold && s.bold,
          variant && s[variant],
          className,
        )}
        {...props}
      />
    );
  },
);

XText.displayName = 'XText';
